"use client";

import { createContext, useContext } from "react";

export interface ExistingFeedback {
  id: string;
  email: string | null;
  understanding: number | null;
  actionability: number;
  relevance: number;
  overall_rating: number | null;
  free_text: string | null;
  created_at: string | null;
}

export interface PresenterProfile {
  avatar_url: string | null;
  first_name: string | null;
  last_name: string | null;
  role: string | null;
  feedback_thank_you_message: string | null;
}

interface AudienceSessionContextValue {
  sessionId: string;
  existingFeedback: ExistingFeedback | null;
  presenterProfile: PresenterProfile | null;
  goToSlideNumber: (n: number) => void;
  hasSlideNumber: (n: number) => boolean;
  goToSplitPage: (index: number) => void;
  presentationId: string;
}

const AudienceSessionContext = createContext<AudienceSessionContextValue>({
  sessionId: "",
  existingFeedback: null,
  presenterProfile: null,
  goToSlideNumber: () => {},
  hasSlideNumber: () => false,
  goToSplitPage: () => {},
  presentationId: "",
});

export function AudienceSessionProvider({
  value,
  children,
}: {
  value: AudienceSessionContextValue;
  children: React.ReactNode;
}) {
  return (
    <AudienceSessionContext.Provider value={value}>
      {children}
    </AudienceSessionContext.Provider>
  );
}

export function useAudienceSession() {
  return useContext(AudienceSessionContext);
}
